module.exports = __webpack_public_path__ + "img/icon_close_600.2f94ecf5.svg";